module.exports = __webpack_public_path__ + "img/099.d451f1a7.png";